module.exports = __webpack_public_path__ + "static/media/industries-metallurgy-s.d08ee5ef.webp";